import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getTnplContractForOrder = {
  name: "getTnplContractForOrder" as const,
  input: z.object({ orderId: zExt.objectId() }),
  output: z.object({
    hasTnplContract: z.boolean(),
    eligibleTnplLineItems: z.array(z.string()),
  }),
};
